import React from 'react'
import { Link } from 'react-router-dom';
import Layout from "../../layout";

const Unauthorized = () => {
  return (
    <Layout
      title="Unauthorized">
      <div className='flex align-items-center justify-content-center' style={{ minHeight: '400px' }}>
        <div className='text-center'>
          <h3 className='mb-4'>Access Denied</h3>
          <Link to="/dashboard" className='btn btn-primary btn-sm'>Dashboard</Link>
        </div>
      </div>
    </Layout>
  )
}

export default Unauthorized